import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import { useFacetData } from '~/context/common/FacetDataContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';

export default function useHasNewCarFacet(): boolean {
  const isDealership = useIsDealershipPage();
  const facetData = useFacetData();

  return isDealership
    ? false
    : facetData?.offerings?.buckets.some(
        facet => facet.key === VehicleOffering.New
      ) ?? false;
}
